import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./scss/po.scss";
import { CONTRACTORS, WORK_ORDER } from "../../../constants/route-paths";
import { getPurchaseOrder } from "../../../actions/project-management.action";
import idx from "idx";
import { numberFormat } from "../../../util/currency-formatter";
import { withRouter } from "../../../util/with-router";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Table from 'react-bootstrap/Table';
import moment from 'moment';
import { Button } from "react-bootstrap";

import WorkOrderInvoicesSection from "../../../components/work-order-invoices-section";

function ViewWorkOrder(props) {
  const [PO, setPO] = useState({});
  const [total, setTotal] = useState(0);
  useEffect(() => {
    getPO();
  }, []);

  const getPO = async () => {
    const poId = props.params.poId;
    const query = `?poId=${poId}`;
    let res = await props.getPurchaseOrder(query);
    setPO(res);
    let totalCost = 0;

    Array.isArray(res.items) &&
      res.items.forEach(({ total }) => (totalCost += total));
    setTotal(totalCost);
  };

  const cancelHandler = () => {
    props.history(`/${CONTRACTORS}/${WORK_ORDER}`);
  };

  return (
    <div className="purchase-order-block" data-cy="wo-details">
      <h2 className="content-heading text-uppercase">View WO</h2>
      <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler} data-cy="breadcrumb-wo">Work Order</Breadcrumb.Item>
          <Breadcrumb.Item active data-cy="breadcrumb-view-wo">View WO</Breadcrumb.Item>
        </Breadcrumb>

      </div>

      <div className="row" data-cy="wo-details-row">
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="wo-number">
            <label>WO Number</label>
            {/* f_id is the WO number with project prefix and Suffix if null then default to wo Number*/}
            <p>{PO.f_id || PO.id}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="vendor-type">
            <label>Vendor Type</label>
            <p>Contractor</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="vendor-name">
            <label>Vendor Name</label>
            <p>{idx(PO, (_) => _.vendor.business_name) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="notes">
            <label>Notes</label>
            <p>{idx(PO, (_) => _.notes) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="street-address">
            <label>Street Address</label>
            <p>{idx(PO, (_) => _.street_address) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="suburb">
            <label>Suburb</label>
            <p>{idx(PO, (_) => _.suburb) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="state">
            <label>State</label>
            <p>{idx(PO, (_) => _.state) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="postcode">
            <label>Postcode</label>
            <p>{idx(PO, (_) => _.postcode) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="country">
            <label>Country</label>
            <p>{idx(PO, (_) => _.country) || "-"}</p>
          </div>
        </div>
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="total">
            <label>Total</label>
            <p>{numberFormat(total)}</p>
          </div>
        </div>
      </div>


      <div className="material-list-block mt-3">
        <div className="table-responsive">
          <Table bordered className="table-create table-material table-material-ch">
            <thead>
              <tr>
                <th className="w-auto" data-cy="name">Name</th>
                <th className="w-auto" data-cy="type">Type</th>
                <th className="text-right" data-cy="quotation">Quotation</th>
              </tr>
            </thead>
            <tbody data-cy="material-list-body">
              {(PO.items || []).map((item, index) => {
                return (
                  <tr key={item.id} data-cy="material-list-item">
                    <td data-cy="name">{item.taskName}</td>
                    <td data-cy="type">{item.taskDescription}</td>
                    <td className="text-right" data-cy="quotation">{numberFormat(item.total)}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </div>

      <WorkOrderInvoicesSection
        poUuid={props.params.poId}
        projectId={PO.projectId}
        vendorType="sub-contractor"
        onNavigate={(invoiceId) => props.history(`/contractors/vendor-payment/view/${invoiceId}?id=${PO.projectId}&poId=${props.params.poId}&type=contractor`)}
      />

      <div className="col-12 d-flex mt-3 justify-content-end">
        <Button type="submit" onClick={cancelHandler} className="secondarybtn cancelbtn" data-cy="cancel-button">BACK</Button>
      </div>

    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseOrder: bindActionCreators(getPurchaseOrder, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewWorkOrder)
);
